
import { Vue, Component } from 'vue-property-decorator'
import { bindingVersionCode, getCompanyInfoByPartner, getCompareCode, partnerCompanyDto,modifyBindingVersionCode } from '@/api/company'
import { Getter } from 'vuex-class'
import { backToBefore } from '@/utils/h5ToApp'
import AddVersionDialog from '@/views/company/template/AddVersionDialog.vue'
import { GetCompanyDtl } from '@/api/company'

@Component({
    components: {AddVersionDialog}
})
export default class AddVersion extends Vue {
    // 版本邀请码
    versionCode = ''

    type = '1' // 1:邀请码 2:版本码

    isDisabled = false // 邀请码是否可编辑 公司已有邀请码之后不可编辑

    created () {
        if (this.$route.query.formPage === 'h5') {
            this.type = '2'
        } else {
            this.type = '1'
            this.getCompanyDtl()
        }
    }

    get placeholder () {
        return this.type === '1' ? '请输入邀请码，仅支持大写字母和数字' : '请输入版本邀请码，仅支持大写字母和数字'
    }

    get title () {
        return this.type === '1' ? '邀请码' : '版本邀请码'
    }

    handleBack () {
        if (this.$route.query.formPage === 'h5') {
            this.type = '2'
            this.$router.back()
        } else {
            backToBefore()
        }
    }

    // 调用获取公司信息接口,获取当前公司的版本码
    getCompanyDtl () {
        GetCompanyDtl({}).then((res) => {
            this.versionCode = res.data.memberInviteCode || res.data.versionCode
            if (this.versionCode) {
                this.isDisabled = true
            }
        })
    }

    // input输入限制（英文、数字）独立编码
    formatterInput (value) {
        return value.replace(/[^a-zA-Z\d]/g, '').toUpperCase()// 大写英文和数字
    }

    bindingVersionCode () {
        if (this.$checkIsEmpty(this.versionCode)) {
            this.$toast('请输入版本邀请码')
        }
        // 匹配邀请码 判断填写的邀请码是否有效
        getCompareCode({versionCode: this.versionCode}).then(res => {
            let params = {
                type: this.type, // 邀请码or版本码 type: 1邀请码，2版本码
                versionCode: this.versionCode
            }
            // 绑定邀请码
            bindingVersionCode(params).then(res => {
                if (res.code === '000000' && this.type === '1') {
                    (this.$refs.dialog as any).show(res.data.companyShortName, res.data.versionCode)
                } else if (this.type === '2') {
                  this.$toast.success({
                    message: `绑定成功`,
                    duration: 1000,
                    onClose: () => {
                      this.enterVersion(res.data.companyShortName,res.data.versionCode)
                    }
                  })
                }
            }).catch(err => {
                this.$toast(err.data.msg)
            })
        }).catch(err => {
            this.$toast(err.data.msg)
        })
    }


    // 切换版本
    enterVersion (companyShortName: string,versionCode: string) {
      this.$confirmDialog.show({
        okText: '确认切换',
        cancelText: '取消',
        tips: `公司名下所有子账号全部将切换至${companyShortName}版本，是否确认切换？`,
        onOk: () => {
          return this.modifyBindingVersionCode(versionCode)
        },
        onCancel: () => {
          this.$router.back()
        }
      })
    }

    modifyBindingVersionCode (versionCode:string) {
      let parma = {
        versionCode:versionCode
      }
      modifyBindingVersionCode(parma).then(res => {
        getCompanyInfoByPartner({partnerCompanyId: res.data.partnerCompanyId}).then((data) => {
          let parmas = {
            partnerLogoUrl: data.data.logoUrl || '', // 合作方Logo
            partnerCompanyId: data.data.companyId || 'system',  // 合作方Id
            partnerCompanyName: data.data.companyName || '南瓜头APP', // 合作方名称
            currentVersionCode: this.versionCode || 'system', // 版本号
            partnerCompanyShortName: data.data.companyShortName || '南瓜头', // 合作方简称
          }
          console.log('调用原生updateuserInfo方法')
          console.log(parmas)
          this.$bridge.callHandler('updateUserInfo', parmas, () => {
            // 调用原生方法返回首页
            this.$bridge.callHandler('backHomes')
          })
        })
    })
  }
}
